import React, { useContext, useEffect, useMemo } from "react";
import Style from "./index.module.css";
import { Link, useParams } from "react-router-dom";
import { LocationContext } from "../../../Contexts/LocationContext";
import { toast } from "react-toastify";

const CatAddCard = ({ AddData }) => {
    const { categoryId } = useParams();
    const { location } = useContext(LocationContext);
    console.log(location, "location");


    console.log("🔹 AddData from props:", AddData);



    // ✅ Memoize filtered ads to prevent unnecessary re-renders
    const showAds = useMemo(() => {
        console.log("Inside showAds ----", AddData);

        if (!Array.isArray(AddData) || AddData.length === 0) {
            console.log("First return: AddData is not an array or is empty", AddData);
            return [];
        }


        return AddData.filter((ad) => {
            console.log("Checking ad:", ad);

            // ❌ Skip if `selectedPage` is null or does not include `categoryId`
            if (ad?.selectedPage === null) {
                console.log("Second return: selectedPage is null for ad:", ad);
                return false;
            }
            if (!ad.selectedPage.includes(categoryId)) {
                console.log(`Second return: selectedPage (${ad.selectedPage}) does not include categoryId (${categoryId})`);
                return false;
            }

            // ✅ Ensure ad matches user's district
            const districtMatch = ad.coverageData?.some((coverage) =>
                coverage.districts?.some(
                    (district) =>
                        typeof district === "string" &&
                        typeof location.district === "string" &&
                        district.toLowerCase().trim() === location.district.toLowerCase().trim()
                )
            );

            console.log("Final return check: District Match:", districtMatch);
            return districtMatch;


        });

    }, [location, AddData, categoryId]);

    useEffect(() => {
        if (location?.error && !location?.loading) {
            toast.error("Location details not found! Please enable location access.");
        }
    }, [location]);

    console.log(showAds, "show ad-----------------------------------------------------------");


    // 🔹 If no ads match, return null (prevents unnecessary renders)
    if (showAds.length === 0) return null;

    return (
        <div className={Style.adContainer}>
            {showAds.map((ad) => {
                const sizeMapping = {
                    1: 235,
                    2: 490,
                    3: 725,
                    4: 960,
                };
                const widthValue = sizeMapping[ad.advSize] || 235;

                return (
                    <div key={ad._id} className={Style.products} style={{ width: `${widthValue}px` }}>
                        <img src={ad.images[0]?.secure_url} alt="Ad" className={Style.card_image} />
                        <Link to={ad.redirectionUrl} target="_blank">
                            <button className={Style.read_more_button}>VISIT SITE</button>
                        </Link>
                    </div>
                );
            })}
        </div>
    );
};

export default CatAddCard;
